<template>
  <div id="app">
    <interface></interface>
  </div>
</template>

<script>
import Interface from "@/components/Interface";
export default {
  name: "App",
  components: {
    Interface
  },
};
</script>

<style>
*{
  margin: 0 ;
  padding: 0;
}
</style>
